import { render, staticRenderFns } from "./PartnersSimple.vue?vue&type=template&id=58523beb"
import script from "./PartnersSimple.vue?vue&type=script&lang=js"
export * from "./PartnersSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports